import type { AgentAiRiskResponse } from "@/api/useInventory.types"

export const getAiAgentRisk = (response: AgentAiRiskResponse) => {
  const { data, metadata, ...rest } = response || {}

  return {
    data: data?.map(({ introducedThrough, ...restData }) => {
      const graph = introducedThrough?.reduce(
        (acc, { agent, tools }) => {
          tools?.forEach(({ tool, sources, sinks }) => {
            const { name } = tool

            sources?.forEach((category) => {
              acc.dataSources.push({
                name,
                category,
                agent
              })
            })

            sinks?.forEach((category) => {
              acc.dataSinks.push({
                name,
                category,
                agent
              })
            })
          })

          return acc
        },
        { dataSources: [], dataSinks: [] } as {
          dataSources: {
            name: string
            category: string
            agent: { id: string; name: string } | null
          }[]
          dataSinks: {
            name: string
            category: string
            agent: { id: string; name: string } | null
          }[]
        }
      )

      return {
        graph,
        introducedThrough,
        ...restData
      }
    }),
    metadata: { ...metadata, total: (metadata?.total ?? data?.length) || 0 },
    ...rest
  }
}
